import axios from '@/utils/http.js';

const urls = {
  login: '/auth/login',
  logout: '/auth/logout',
  updateUserPwd: '/auth/updateUserPwd',
};

export const login = function (options) {
  options.url = urls.login;
  return axios.post(options);
};
export const logout = function (options) {
  options.url = urls.logout;
  return axios.get(options);
};
export const updateUserPwd = function (options) {
  options.url = urls.updateUserPwd;
  return axios.post(options);
};
